var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "changePasswordModal",
        size: "md",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.change_password"),
      },
      on: {
        hide: function ($event) {
          return _vm.resetValues()
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.close")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.updatePassword()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.update")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("b-input-group-form-input", {
        attrs: {
          id: "password-input",
          "input-group-size": "mb-3",
          type: "password",
          lazy: "true",
          required: "true",
          feedback: "true",
          autofocus: "false",
          label: _vm.$t("message.password"),
          "feedback-text": _vm.$t("admin.required_password"),
        },
        model: {
          value: _vm.newPassword,
          callback: function ($$v) {
            _vm.newPassword = $$v
          },
          expression: "newPassword",
        },
      }),
      _c("b-input-group-form-input", {
        attrs: {
          id: "confirmPassword-input",
          "input-group-size": "mb-3",
          type: "password",
          lazy: "true",
          required: "true",
          feedback: "true",
          autofocus: "false",
          state: _vm.verifyPasswordState(),
          label: _vm.$t("admin.password_confirm"),
          "feedback-text": _vm.$t("admin.required_confirmPassword"),
        },
        model: {
          value: _vm.confirmPassword,
          callback: function ($$v) {
            _vm.confirmPassword = $$v
          },
          expression: "confirmPassword",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }